import { Link } from '@mui/material';
import styled from 'styled-components';

export const CustomTimerLink = styled(Link)`
  ${({ disabled }) =>
    disabled &&
    `
      cursor: default;
      opacity: 0.3;
    `}
`;
